import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Badge } from "../ui/badge";
import { Package } from "lucide-react";
import { api } from "../../lib/api";

const fmtEur = (v) => v == null ? "–" : new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);
const fmtNum = (v) => new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(v || 0);

// Articles bought from this supplier + aggregated qty & revenue (spend cube).
export function SupplierArticlesSpend({ supplierId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/suppliers/${supplierId}/articles-spend`).then((r) => setData(r.data)).catch(() => setData({ articles: [], count: 0 }));
  }, [supplierId]);

  if (!data) return <div className="text-sm text-gray-400 p-4">Lädt …</div>;
  const showAmount = data.articles.some((a) => a.amount != null) || data.total_amount != null;

  return (
    <div className="space-y-4" data-testid="supplier-articles-spend">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Package className="h-5 w-5 text-[#1B2A4A]" />
          <h3 className="font-semibold text-[#1B2A4A]">Artikel & Umsatz</h3>
        </div>
        {data.total_amount != null && (
          <div className="text-right">
            <div className="text-xs text-gray-400">Einkaufsvolumen (12 M.)</div>
            <div className="text-lg font-bold text-[#1B2A4A]" data-testid="supplier-spend-total">{fmtEur(data.total_amount)}</div>
          </div>
        )}
      </div>
      <div className="rounded-xl border border-gray-200 bg-white overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Artikel</TableHead>
              <TableHead>Warengruppe</TableHead>
              <TableHead className="text-right">Menge</TableHead>
              {showAmount && <TableHead className="text-right">Umsatz</TableHead>}
              <TableHead>Werke</TableHead>
              <TableHead>Letzter Bezug</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.articles.length === 0 && (
              <TableRow><TableCell colSpan={showAmount ? 6 : 5} className="text-center text-gray-400 py-8">
                Noch keine Einkaufsdaten für diesen Lieferanten.
              </TableCell></TableRow>
            )}
            {data.articles.map((a, i) => (
              <TableRow key={a.article_id || i} data-testid={`supplier-article-row-${i}`}>
                <TableCell className="font-medium">{a.article_name}</TableCell>
                <TableCell className="text-sm text-gray-500">{a.category || "–"}</TableCell>
                <TableCell className="text-right">{fmtNum(a.qty)} {a.base_uom}</TableCell>
                {showAmount && <TableCell className="text-right font-medium">{fmtEur(a.amount)}</TableCell>}
                <TableCell><div className="flex flex-wrap gap-1">{(a.plants || []).map((pl) => <Badge key={pl} variant="outline" className="text-[10px]">{pl}</Badge>)}</div></TableCell>
                <TableCell className="text-xs text-gray-500">{(a.last_date || "").slice(0, 10)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
